import Flickity from 'flickity';
import {
  appendSlides,
  positionUls,
  assignNavHeightValues,
  slideToSlide,
  scrollToTop,
  initialMenuState,
  offsetClickIndex,
  crumbObserver
} from '../../modules/navigation/nav-helpers';

import fizzyUIUtils from 'fizzy-ui-utils';

export function initNavigation(touch) {
  var navigationToggle = document.querySelector('.navigation__toggle'),
    navigationMenu = document.querySelector('#menu-header-menu.navigation__menu'),
    scrollTop = document.querySelector('.top-of-page'),
    dragIgnoreClickDelay = 75,
    dragTimeout = false,
    dragging = false;

  const slideshowEl = document.querySelector('.navigation__slider');
  let barbacontainer = document.querySelector('[data-barba="container"]');

  navigationMenu.setAttribute("data-active-tier-index", "0");

  offsetClickIndex(navigationMenu); // Set initial offset click index on the menu item
  crumbObserver(barbacontainer); // Set initial intersection observer to the crumb

  positionUls(); // Position UL
  appendSlides(); // Appends slides
  assignNavHeightValues(); // Keep this

  Flickity.createMethods.push('_createPrevNextCells');

  Flickity.prototype._createPrevNextCells = function () {
    this.on('select', this.setPrevNextCells);
  };

  Flickity.prototype.setPrevNextCells = function () {
    // Remove classes
    changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
    changeSlideClasses(this.nextSlide, 'remove', 'is-next');
    // Set slides
    var previousI = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);
    var nextI = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);
    this.previousSlide = this.slides[previousI];
    this.nextSlide = this.slides[nextI];
    // Add classes
    changeSlideClasses(this.previousSlide, 'add', 'is-previous');
    changeSlideClasses(this.nextSlide, 'add', 'is-next');
  };

  function changeSlideClasses(slide, method, className) {
    if (!slide) {
      return;
    }
    slide.getCellElements().forEach(function (cellElem) {
      cellElem.classList[method](className);
    });
  }

  var allowDraggable = touch; // If false, it's mouse; if true, it's touch

  // Initialize Flickity
  let flickityNav = new Flickity(slideshowEl, {
    autoPlay: false,
    prevNextButtons: false,
    pageDots: false,
    draggable: allowDraggable,
    wrapAround: false,
    selectedAttraction: 0.2,
    friction: 0.8,
    resize: true,
    cellAlign: 'left',
    watchCSS: false,
    on: {
      dragStart: function () {
        console.log("drag START");
        clearTimeout(dragTimeout);
        dragging = true;
        document.querySelectorAll('.navigation__slide a').forEach(function (anchor) {
          anchor.style.pointerEvents = 'none';
        });
      },
      dragEnd: function () {
        document.querySelectorAll('.navigation__slide a').forEach(function (anchor) {
          anchor.style.pointerEvents = 'initial';
        });
        dragTimeout = setTimeout(function () {
          dragging = false;
        }, dragIgnoreClickDelay);
      },
      activate: function () {
        // Optional activation logic
      },
      ready: function () {
        // Once the slider is ready, set the initial menu state
        initialMenuState(this);
      }
    }
  });

  // I've re-instated this jquery based code - as it worked.
  // there are instances - which may be unrleated to the nav - in which the loading screen hangs
  // suggesting after a barba change = the loading class isn ot removed
  // this may also be a result of other class changes happening after the barba "last event" class changes?


  
  $(navigationMenu).find('li.menu-item-has-children > a').on('click', function () { //1st tier 

    if (dragging) return false; // review

    var $liitem = $(this).parent("li"),
      $ulmenu = $liitem.find("ul").first(), // current ul item
      parents = $ulmenu.parentsUntil($(".navigation__menu"), "ul").length, // figuring out how many parent uls the current ul items has
      previoustiernumber = $(navigationMenu).attr('data-active-tier-index'), // where were we (tier wise) before we clicked on this link
      thistiernumber = parents, // ther tier we are befor any sliding ahppend
      // targettiernumber,// this is teh what we don't know yet/ utnill we dtermine if the item is active = (thistiernumber ), // the tier we end up after sliding click - start with  -- there targ
      tierdifference = ((thistiernumber - previoustiernumber)), // the differene between the current tier and the previous tier
      $allulmenus = $liitem.parent("ul").find("ul"), //  this targets all ul's in this sub including itself
      $allulli = $liitem.parent("ul").find("ul").parent("li"), // this targets the containing ul li's
      offsetClickIndex =  $(navigationMenu).attr("data-offset-click-index"); // figure out the offest click value based on number of slides per breakpoing view
 
    if ($ulmenu.hasClass('sub-active')) {
      var targettiernumber = ((thistiernumber)); // + tierdifference); // ut minuse previ rvie this is it mius or plus or different value
      var slideIndex = (thistiernumber - offsetClickIndex);
      // console.log("slideIndex", slideIndex);

      //  remove all active classes
      $allulmenus.removeClass('sub-active');
      $allulli.removeClass('sub-active');
      $allulli.parent('ul').removeClass('child-active');

      // update the data attribut with the active tier so we can keep track of it when we next click
      $(navigationMenu).attr("data-active-tier-index", targettiernumber);
      // console.log("the active tier after sliding equals ", targettiernumber, "REady for the next click event");
      // set this befor ethe sliding happens so the cchange function recognisses the new + desired nd not previous tiernumber

      if (slideIndex >= (-1 * (offsetClickIndex))) {
        // if the slide index is greater than or equal to the offset click index we slide to the target tier
        console.log("targettiernumber", targettiernumber);
        slideToSlide(flickityNav, (targettiernumber));

      }

    } else {
      // if it is not active we need to know where we are coming from in order ot figure out the target tier
      // console.log("link is not active and thistiernumber =", thistiernumber, "");

      var targettiernumber = (thistiernumber + 1); // if not active we  go to thistier +1 -
      //  no wouldn't be + 1?! For exampoe if I was clicking deeper into the ul's I would wanna target that tier
      // console.log("the targettiernumber", targettiernumber, "");

      var slideIndex = (thistiernumber - offsetClickIndex);
      // console.log("slideIndex", slideIndex);

      // remove all first:
      $allulmenus.removeClass('sub-active');
      $allulli.removeClass('sub-active');

      // console.log("making sub-active");
      $liitem.parent('ul').addClass('child-active');
      $liitem.addClass('sub-active');
      $ulmenu.addClass('sub-active');
      $(navigationMenu).attr("data-active-tier-index", targettiernumber);
      // console.log("the active tier after sliding equals ", targettiernumber, "REady for the next click event");

      if (slideIndex >= 0) { // ony once we hit or base index do we start sliding
    
        slideToSlide(flickityNav, (targettiernumber - offsetClickIndex)); // - offsetClickIndex)));

      }

    } //if ($ulmenu.hasClass('sub-active')) 

  });
// this was a javascript only version of the above jquery code - provided by chatgpt - issues arised with the click event not firing
  // document.querySelectorAll('#menu-header-menu.navigation__menu li.menu-item-has-children > a').forEach(function (anchor) {
  //   anchor.addEventListener('click', function (event) {
  //     if (dragging) return false; // Prevent if dragging - nar this is fucked - why would U return this function if we allow dragging?!

  //     var liItem = this.parentElement,
  //       ulMenu = liItem.querySelector("ul"),
  //       parents = 0,
  //       parentElement = ulMenu;

  //     while (parentElement.parentElement && parentElement !== document.querySelector(".navigation__menu")) {
  //       if (parentElement.tagName.toLowerCase() === "ul") {
  //         parents++;
  //       }
  //       parentElement = parentElement.parentElement;
  //     }

  //     var previousTierNumber = navigationMenu.getAttribute('data-active-tier-index'),
  //       thisTierNumber = parents,
  //       tierDifference = thisTierNumber - previousTierNumber,
  //       allUlMenus = liItem.parentElement.querySelectorAll("ul"),
  //       parentUl = liItem.parentElement,
  //       allUlMenus = parentUl.querySelectorAll("ul"),
  //       allUlLi = Array.from(allUlMenus).map(function (ul) {
  //         return ul.parentElement;
  //       }),
  //       offsetClickIndex = navigationMenu.getAttribute("data-offset-click-index");

  //     console.log("parents", parents);
  //     console.log("previousTierNumber", previousTierNumber);
  //     console.log("thisTierNumber", thisTierNumber);
  //     console.log("tierDifference", tierDifference);
  //     console.log("allUlMenus", allUlMenus);
  //     console.log("allUlLi", allUlLi);
  //     console.log("offsetClickIndex", offsetClickIndex);

  //     if (ulMenu.classList.contains('sub-active')) {
  //       var targetTierNumber = thisTierNumber;

  //       // Remove active classes
  //       if (allUlMenus.length > 0) {
  //         allUlMenus.forEach(function (ul) {
  //           ul.classList.remove('sub-active');
  //         });
  //       }
  //       if (allUlLi.length > 0) {
  //         allUlLi.forEach(function (li) {
  //           li.classList.remove('sub-active');
  //         });
  //       }
  //       liItem.parentElement.classList.remove('child-active');

  //       navigationMenu.setAttribute("data-active-tier-index", targetTierNumber);
  //       console.log("the active tier after sliding equals ", targetTierNumber, "Ready for the next click event");

  //       if (thisTierNumber - offsetClickIndex >= (-1 * offsetClickIndex)) {
  //         console.log("targetTierNumber", targetTierNumber);
  //         slideToSlide(flickityNav, targetTierNumber);
  //       }

  //     } else {
  //       var targetTierNumber = thisTierNumber + 1;

  //       // Remove all active classes
  //       if (allUlMenus.length > 0) {
  //         allUlMenus.forEach(function (ul) {
  //           ul.classList.remove('sub-active');
  //         });
  //       }
  //       if (allUlLi.length > 0) {
  //         allUlLi.forEach(function (li) {
  //           li.classList.remove('sub-active');
  //         });
  //       }
  //       liItem.parentElement.classList.add('child-active');
  //       liItem.classList.add('sub-active');
  //       ulMenu.classList.add('sub-active');

  //       navigationMenu.setAttribute("data-active-tier-index", targetTierNumber);
  //       console.log("the active tier after sliding equals ", targetTierNumber, "Ready for the next click event");

  //       if (thisTierNumber - offsetClickIndex >= 0) {
  //         slideToSlide(flickityNav, targetTierNumber - offsetClickIndex);
  //       }
  //     }

  //     return false; // Prevent default action
  //   });
  // });

  scrollTop.addEventListener('click', function () {
    scrollToTop();
  });


  // console.log("navigationToggle", navigationToggle);

  // Navigation toggle event
  navigationToggle.addEventListener('click', function () {

    if (this.classList.contains('toggled-on')) {
      this.classList.remove('toggled-on');
      document.body.classList.remove('toggled-on');
      navigationMenu.classList.remove('toggled-on');
    } else {
      this.classList.add('toggled-on');
      document.body.classList.add('toggled-on');
      navigationMenu.classList.add('toggled-on');
    }

    assignNavHeightValues(); // Adjust navigation height
  });

  window.addEventListener('resize', function () {
    // Update offset click index
    offsetClickIndex(navigationMenu);
  });

 
  // Return Flickity instance for external use (inside barba)
  return flickityNav;
}
